import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * ScrollProgressBar — thin progress bar at the top of the viewport that
 * tracks how far down the page the user has scrolled.
 */
const ScrollProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const width = useSpring(scrollYProgress, { stiffness: 120, damping: 25, restDelta: 0.001 });
  return (
    <motion.div
      style={{ scaleX: width, transformOrigin: '0 0' }}
      className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#FF6B4A] via-[#FBBF24] to-[#FF6B4A] z-[100] origin-left"
    />
  );
};

export default ScrollProgressBar;
